import React, { useCallback, useState } from 'react';
import { Box, Button, Card, CardActionArea, CardContent, CardHeader, CardMedia, Grid, Link, List, ListItem, Stack, Tooltip, Typography } from '@mui/material';
import { BuilderProduct } from '@/store/builderSlice';
import ProductThumbnail from './ProductThumbnail';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDragLayer } from 'react-dnd';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const CustomDragPreview = () => {
  const { itemType, isDragging, item, initialOffset, currentOffset } =
    useDragLayer((monitor) => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    }))

  if (!isDragging || !item || !currentOffset) {
    document.getElementById("builderApp")!.style.cursor = 'auto'
    return null;
  }
  const imageAR = item.imageRef.width / item.imageRef.height;
  if (isDragging)
    document.getElementById("builderApp")!.style.cursor = 'grabbing';

  return (
    <div style={{
      position: 'fixed',
      pointerEvents: 'none',
      zIndex: 1000,
      left: currentOffset.x,
      top: currentOffset.y - 60
    }}>
      <AddCircleOutlinedIcon
        fontSize="large"
        style={{
          color: '#FE6526', position: 'absolute',
          top: 125 / 2,
          left: (125 * imageAR) / 2,
        }}
      />
      {<img
        src={item.imageRef.src}
        style={{ height: '125px' }}
      />}

    </div>
  );
};

export default function ProductListView(props: { products: BuilderProduct[]; closeProductsView: Function | undefined; maxHeight: number }) {

  const [selectedProduct, setSelectedProduct] = useState<string | undefined>(undefined);
  const addAllProductsToRoom = useCallback(() => {
    console.log('add all products to room');
  }, []);

  const toggleSelectedProduct = (productId: string) => {
    const selectedProductId = !selectedProduct || selectedProduct !== productId
      ? productId
      : undefined;
    setSelectedProduct(selectedProductId);
  }
  return (
    <>
      <List sx={{ overflow: 'initial', overflowX: 'hidden', width: '100%', padding:"5px", maxWidth: '100%', bgcolor: 'background.paper' }}>
        {props.products.map((product: BuilderProduct, index: Number) => (
          <ListItem key={index + product.productId} sx={{padding: '5px 0'}}>
            <Card id={product.productId}
              sx={{
                maxWidth: '100%',
                boxShadow: 'unset',
                padding: '5px',
                ":hover": {
                  borderColor: "primary.main",
                  borderWidth: "2px",
                  borderStyle: "solid",
                  borderRadius: '12px'
                },
              }}>
              <Box
                component={'div'}
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  bgcolor: 'rgba(236, 240, 241, 0.6)',
                  color: 'white',
                  padding: '10px',
                  zIndex: 99,
                  visibility: selectedProduct && selectedProduct === product.productId ? 'visible' : 'hidden'
                }}
                onClick={() => toggleSelectedProduct(product.productId)}
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ width: 1, height: "100%" }}
                >
                  <Typography gutterBottom variant="h5" component="div"
                    sx={{
                      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                    }}
                  >
                    {product.productName}
                  </Typography>
                </Stack>

              </Box>
              <Box component={'div'}>
                <Grid container justifyContent="center">
                  <Grid item>
                    <Typography variant="body2"
                      sx={{
                        color: 'primary',
                        lineHeight: '15px',
                        textAlign: 'left',
                      }}>${product.price}</Typography>
                  </Grid>
                  <Grid item style={{ marginLeft: 'auto' }}>
                    <InfoOutlinedIcon
                      fontSize="medium"
                      style={{ color: 'black' }}
                      onClick={() => toggleSelectedProduct(product.productId)}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Tooltip
                title={<Typography fontSize={14} color={'white'}>Drag and drop to add product to the room</Typography>}
                arrow
                PopperProps={{
                  style: { zIndex: 99999999, width: 200, opacity: 0.75 },
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, 0],
                      },
                    },
                  ],
                }}
                placement="right"
                open={selectedProduct && selectedProduct === product.productId ? false : undefined}
              >
                <Grid container justifyContent="center">
                  {product.availability == "Available" && <CustomDragPreview />}
                  {product.availability !== "Available" && 
                    <Typography
                      sx={{
                        position: 'relative',
                        top: '50px',
                        background: '#808080a8',
                        color: 'white',
                        fontWeight: 700,
                        fontSize: '12px',
                      }}
                    >
                      Unavailable
                    </Typography>
                  }
                  <ProductThumbnail product={product} />
                  <Typography variant="body2"
                    sx={{
                      color: 'primary',
                      paddingTop: '5px',
                      lineHeight: '15px',
                      textAlign: 'center',
                      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                      }}>{product.productName}</Typography>
                </Grid>
              </Tooltip>
            </Card>
          </ListItem>
        ))}
      </List >
    </>
  );
}